import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import REGEX from '../../../config/regex';
import jsonPost from '../../../util/jsonPost';

import Button from '../Atoms/Button';
import Input from '../Atoms/Input';
import ErrorMessage from '../Core/ErrorMessage';

const propTypes = exact({
  apiURL: PropTypes.string.isRequired,
  buttonSubmitText: PropTypes.string.isRequired,
  loginPasswordHeading: PropTypes.string.isRequired,
  loginPasswordPlaceholderText: PropTypes.string.isRequired,
  loginUserNameHeading: PropTypes.string.isRequired,
  loginUserNamePlaceholderText: PropTypes.string.isRequired,
  siteId: PropTypes.number,
  validationMissingFields: PropTypes.string.isRequired,
  validationEmailAddressInvalid: PropTypes.string.isRequired,
});

const defaultProps = {
  siteId: null,
};

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResetState = this.handleResetState.bind(this);

    this.loginFormFieldSets = [
      {
        fieldName: 'emailAddress',
        heading: props.loginUserNameHeading,
        inputType: 'text',
        isRequired: true,
        key: 1,
        placeholder: props.loginUserNamePlaceholderText,
      },
      {
        fieldName: 'password',
        heading: props.loginPasswordHeading,
        inputType: 'password',
        isRequired: true,
        key: 2,
        placeholder: props.loginPasswordPlaceholderText,
      },
    ];

    this.state = {
      emailAddress: '',
      password: '',
      errorMessage: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    window.addEventListener('pageshow', this.handleResetState);
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handleResetState);
  }

  handleResetState() {
    this.setState({ isLoading: false });
  }

  handleFieldChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { siteId } = this.props;
    const { emailAddress, password } = this.state;

    if (!emailAddress && !password) {
      return this.setState({ errorMessage: this.props.validationMissingFields });
    }

    if (!REGEX.email.test(emailAddress)) {
      return this.setState({ errorMessage: this.props.validationEmailAddressInvalid });
    }

    this.setState({
      errorMessage: null,
      isLoading: true,
    });

    const options = {
      emailAddress,
      password,
      siteId,
    };

    return jsonPost(this.props.apiURL, options, (response) => {
      if (!response.success) {
        return this.setState({
          errorMessage: response.message || 'Login failed',
          isLoading: false,
        });
      }

      window.location.href = response.redirectUri;
      return true;
    });
  }

  render() {
    return (
      <div className="LoginForm">
        <form className="LoginForm_form" autoComplete="off" noValidate>
          <div className="LoginForm_content">
            <div className="LoginForm_column LoginForm_column-inset">
              <div className="LoginForm_item">
                {this.loginFormFieldSets.map((field) => (
                  <div className="LoginForm_item LoginForm_item-1" key={field.key}>
                    <h4 className="LoginForm_itemHeading">{field.heading}</h4>
                    <Input
                      fieldName={field.fieldName}
                      fieldValue={this.state[field.fieldName]}
                      handleChange={this.handleFieldChange}
                      inputType={field.inputType}
                      isRequired={field.isRequired}
                      modifier="ghost"
                      placeholderText={field.placeholder}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="LoginForm_column">
              <div className="LoginForm_submit">
                {this.state.errorMessage && (
                  <div className="LoginForm_item">
                    <ErrorMessage text={this.state.errorMessage} />
                  </div>
                )}
                <div className="LoginForm_item LoginForm_item-center">
                  <Button
                    buttonType="submit"
                    handleClick={this.handleSubmit}
                    isLoading={this.state.isLoading}
                    modifier="fill"
                    text={this.props.buttonSubmitText}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

LoginForm.defaultProps = defaultProps;
LoginForm.propTypes = propTypes;

export default LoginForm;
